import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, share } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { RcApiService } from '../rc-api/rc-api.service';
import { RcEventBusService } from '../rc-event-bus/rc-event-bus.service';

@Injectable({ providedIn: 'root' })
export class RcAuthService {
    authUrl: string;
    constructor(@Inject('ENVIRONMENT') private environment: any, private api: RcApiService,
               private http: HttpClient, private eventBus: RcEventBusService) {
      // TODO: remove httpclient (from here and from module) and use api when set for headers will be available
        this.authUrl = `${this.environment.baseUrl}/api/auth`;
    }
    //TODO: add models
    login(username: string, password: string, recaptchaToken: string) {

        return this.api.post(this.authUrl + '/Login', { username, password, recaptchaToken })
            .pipe(map((res: any) => {
                // login successful if there's a jwt token in the response
                if (res.content && res.content.access_Token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(res.content));
                    this.eventBus.emit('USER-LOGIN-CHANGED', true);
                }

                return res.content;
            }));
    }
    OTPSend(username: string, phoneNumber: string, recaptchaToken: string, ) {
      return this.api.post(this.authUrl + '/OTPSend', { username: username, phoneNumber, recaptchaToken });
    }
    OtpConfirm(username: string, OtpCode: number,  recaptchaToken: string, claims: any) {
      return this.api.post(this.authUrl + '/OTPConfirm', { username, OtpCode, recaptchaToken, claims });
    }

    generateToken(userClaims) {
      return this.api.post(`${this.authUrl}/GenerateToken`, userClaims).pipe(map((res: any)  => {
        // login successful if there's a jwt token in the response
        if (res.content && res.content.access_Token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(res.content));
          this.eventBus.emit('USER-LOGIN-CHANGED', true);

      }
      return res.content;
      }));
    }

    facebookLogin(accessToken: string) {
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      const body = JSON.stringify({ accessToken });
      return this.http
        .post(
        this.environment.authUrl + '/facebook', body, { headers })
        .pipe(map((user: any) => {
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.eventBus.emit('USER-LOGIN-CHANGED', true);
          return;
        }));
    }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.eventBus.emit('USER-LOGIN-CHANGED', false);
    }
    refreshToken(): Observable<string> {
        // append refresh token if you have one
        const currentUser =  localStorage.getItem('currentUser');
        if (!currentUser) {
            return;
        }
        const userObj = JSON.parse(currentUser);
        const refreshToken = userObj.refreshToken;

        return this.http
          .get(this.authUrl + '/RefreshToken', {
            headers: new HttpHeaders().set('refreshToken', refreshToken),
            observe: 'response'
          })
          .pipe(
            share(), // <========== YOU HAVE TO SHARE THIS OBSERVABLE TO AVOID MULTIPLE REQUEST BEING SENT SIMULTANEOUSLY
            map((res: any) => {
                userObj.access_Token = res.body.content.access_Token;
                userObj.refreshToken =  res.body.content.refreshToken;
                localStorage.setItem('currentUser', JSON.stringify(userObj));
                this.eventBus.emit('USER-LOGIN-CHANGED', true);
                return '';
           })
        );
    }
}
